import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AiPages } from '../core/constants/shared.constants';
import { MenuItem } from '../core/interfaces/menu-items';

@Component({
  selector: 'app-ai',
  templateUrl: './ai.component.html',
  styleUrls: ['./ai.component.scss']
})
export class AiComponent implements OnInit {

  public module: string = "AI";
  public title: string = "";
  public menuItems: MenuItem[];

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    //this.module = this.route.snapshot.data.module;
    this.title = this.route.snapshot.data.menuTitle;
    this.getMenuItems();
  }

  private getMenuItems() {
    this.menuItems = [
      {
        title: 'Overview',
        url: `/ai/${AiPages.Overview}`
      },
      {
        title: "Intents",
        url: `/ai/${AiPages.Intents}`
      },
      {
        title: "Entities",
        url: `/ai/${AiPages.Entity}`,
        children: [
          {
            title: 'List',
            url: `/ai/${AiPages.Entity}/list`
          },
          {
            title: 'Regular expression',
            url: `/ai/${AiPages.Entity}/regex`
          },
          {
            title: 'Machine learned',
            url: `/ai/${AiPages.Entity}/machine-learned`
          }
        ]
      },
      {
        title: "Publish",
        url: `/ai/${AiPages.Publish}`
      },
      {
        title: "Prediction",
        url: `/ai/${AiPages.BotPrediction}`
      },
      {
        title: "Chatbot",
        url: `/ai/${AiPages.Chatbot}`,
        children: [
          {
            title: 'Say',
            url: `/ai/${AiPages.Chatbot}/say`
          },
          {
            title: 'Menu',
            url: `/ai/${AiPages.Chatbot}/menu`
          },
          {
            title: 'Collect',
            url: `/ai/${AiPages.Chatbot}/collect`
          },
          {
            title: 'Redirect',
            url: `/ai/${AiPages.Chatbot}/redirect`
          },
          {
            title: 'Callback',
            url: `/ai/${AiPages.Chatbot}/callback`
          },
          {
            title: 'Display',
            url: `/ai/${AiPages.Chatbot}/display`
          },
          {
            title: 'SetParameter',
            url: `/ai/${AiPages.Chatbot}/set-parameter`
          },
          {
            title: 'Listen',
            url: `/ai/${AiPages.Chatbot}/listen`
          },
          {
            title: 'StatusCallback',
            url: `/ai/${AiPages.Chatbot}/status-callback`
          },
          {
            title: 'LiveAgent',
            url: `/ai/${AiPages.Chatbot}/live-agent`
          }
        ]
      },
      {
        title: "Rephrase with ChatGPT",
        url: `/ai/${AiPages.RephraseInstructions}`
      },
    ];
  }

}
